<template>
  <div class="sub-sidebar-menu">
    <template v-for="section in sections">
      <div :key="`${section.key}-title`" class="sub-sidebar-menu__section-title">{{ $t(section.title) }}</div>
      <div :key="section.key" class="sub-sidebar-menu__section-item-container">
        <router-link
          v-for="item in section.items"
          :key="item.path"
          active-class="sub-sidebar-menu__section-item-content selected"
          class="sub-sidebar-menu__section-item-content"
          :to="item.path"
        >
          <span>{{ $t(item.label) }}</span>
          <BaseIcon v-if="isPhone" name="chevron-right" class="sub-sidebar-menu__chevron" />
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseIcon from '@/components/base/BaseIcon';
import { settingsMenu } from '@/components/layout/settings-menu';
import { viewport } from '@/util/viewport';

export default {
  name: 'SubSidebarMenu',
  components: { BaseIcon },
  computed: {
    ...mapGetters('auth', ['isAdminTenant', 'isAdmin', 'isManager']),
    sections() {
      return settingsMenu({ isManager: this.isManager, isAdminTenant: this.isAdminTenant, isAdmin: this.isAdmin });
    },
    // Phones list the settings on a screen of their own, each line leading to its page.
    isPhone() {
      return viewport.size === 'phone';
    },
  },
};
</script>

<style lang="scss">
.sub-sidebar-menu {
  height: 79.5vh;
  width: 250px;
  background: $color-white;
  border-radius: $border-radius-root 0 0 $border-radius-root;
  margin: 32px 0 32px 32px;
  padding-top: 32px;
  overflow: auto;

  &__section-title {
    font-size: 13px;
    color: rgba($color-normal-pale, 0.6);
    text-transform: uppercase;
    padding: 8px 16px;
  }

  &__section-item-container {
    display: flex;
    flex-direction: column;
    padding-top: 4px;
    margin-bottom: 32px;
  }

  &__section-item-content {
    position: relative;
    padding: 8px 16px;
    background: transparent;
    margin-bottom: 4px;
    width: 100%;
    text-decoration: none;
    color: $color-normal;

    &.selected {
      background: $color-accent-100 !important;
      color: $color-accent;
      transition: all 200ms ease-in;

      &:before {
        position: absolute;
        background: $color-accent;
        content: '';
        display: block;
        height: 16px;
        width: 4px;
        left: -2px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    &:hover {
      background: $color-hover;
    }
  }

  &__chevron {
    flex: none;
    width: 20px;
    height: 20px;
    margin-left: auto;
    color: $color-slate-400;
  }

  // Phones: the whole screen, one 48px line per page.
  @include screen-below('tablet') {
    width: auto;
    height: auto;
    margin: $phone-page-gutter;
    padding: 8px 0;
    border-radius: $border-radius-root;
    overflow: visible;

    &__section-item-container {
      margin-bottom: 16px;
    }

    &__section-item-content {
      display: flex;
      align-items: center;
      min-height: 48px;
      margin-bottom: 0;
      font-size: 15px;
    }
  }
}
</style>
